import { Controller } from '@hotwired/stimulus';
import { useBootstrap } from '../composables/bootstrap';

// MVK-3407 — modal "Chọn khu vực" (#locationModal), thay Vue `Regions`. Nội dung là fragment Twig
// (RegionController::pickerFragment), chỉ tải khi modal MỞ lần đầu (MVK-3385: modal có trên mọi trang).
// Fragment không phụ thuộc cookie (cache shared) ⇒ tỉnh đang chọn được đánh dấu ở đây.
export default class extends Controller {
    static targets = ['search', 'item'];
    static values = { url: String, modal: String };
    // app.js gán object `root` (cookie tỉnh, loading) trước khi đăng ký controller.
    static root = null;

    connect() {
        const { onModalShow, isModalShown } = useBootstrap();
        this.loaded = false;
        this.unsubscribe = onModalShow(this.modalValue, () => this.load());
        // Modal đã mở (hoặc đang mở dở) trước khi controller connect: sự kiện đã qua ⇒ tải ngay.
        if (isModalShown(this.modalValue)) this.load();
    }

    disconnect() {
        if (this.unsubscribe) this.unsubscribe();
    }

    async load() {
        if (this.loaded) return;
        this.loaded = true;
        try {
            const response = await fetch(this.urlValue, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            this.element.innerHTML = await response.text();
            this.markSelected();
        } catch (error) {
            // Lần mở modal sau thử lại.
            this.loaded = false;
        }
    }

    markSelected() {
        const current = Number(this.constructor.root.getRegion());
        this.itemTargets.forEach((item) => {
            const check = item.querySelector('[data-region-picker-target="check"]');
            if (check) check.classList.toggle('d-none', Number(item.dataset.regionId) !== current);
        });
    }

    filter() {
        const term = this.searchTarget.value.toLowerCase();
        this.itemTargets.forEach((item) => {
            const match = term === '' || item.dataset.name.includes(term) || (item.dataset.alias && item.dataset.alias.includes(term));
            item.classList.toggle('d-none', !match);
            // `d-flex` của Bootstrap là !important ⇒ phải gỡ nó thì `d-none` mới ẩn được.
            item.classList.toggle('d-flex', match);
        });
    }

    ignore(event) {
        event.preventDefault();
    }

    choose(event) {
        event.preventDefault();
        const item = event.currentTarget;
        const root = this.constructor.root;
        const regionId = Number(item.dataset.regionId);
        if (Number(root.getRegion()) !== regionId) {
            root.setRegion(regionId);
            root.loading();
            window.location = item.href;
        }
        useBootstrap().closeModal(this.modalValue);
    }
}
